import { render, staticRenderFns } from "./SaveCompanyUserForm.vue?vue&type=template&id=b935bf08&"
import script from "./SaveCompanyUserForm.vue?vue&type=script&lang=js&"
export * from "./SaveCompanyUserForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports